import React from "react";
import * as LucideIcons from "lucide-react";

const Icon = ({ name, size, color, className = "", ...props }) => {
  const IconComponent = LucideIcons[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in lucide-react`);
    return null;
  }

  return (
    <IconComponent
      size={size || 24}
      color={color || "currentColor"}
      className={className}
      {...props}
    />
  );
};

Icon.displayName = "Icon";

export { Icon };
